import { apiGet, apiPatch } from './client';
import type { RatingLevel, RatingLevelBatchRequest } from '../types/RatingLevel';

// RatingLevels is Central (bank-wide) — NoTenantContext, no X-Tenant-Id needed.
export function getRatingLevels(): Promise<RatingLevel[]> {
  return apiGet<RatingLevel[]>('/api/rating-levels');
}

export function saveRatingLevelsBatch(
  added: RatingLevel[],
  modified: RatingLevel[],
  deletedIds: number[],
): Promise<RatingLevel[]> {
  return apiPatch<RatingLevelBatchRequest, RatingLevel[]>(
    '/api/rating-levels/batch',
    { added, modified, deleted: deletedIds },
  );
}
